var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-quote-right';
                    var viewUrl = 'sprite.svg#view-icon-quote-right';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 56 48',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };